import branch from './branch.png';
import customer from './customer.png';
import supplier from './supplier.png';
import alternativeSite from './alternativeSite.png';

export default { branch, customer, supplier, alternativeSite };
